<!-- PWAPrompt.vue -->
<template>
  <b-toast
    id="install-iOS-app-toast"
    variant="primary"
    title="Download the Agendum App?"
    noAutoHide
    solid
    toaster="b-toaster-bottom-full"
    :visible="shown"
  >
    <div
      class="w-100 d-flex flex-sm-row flex-column justify-content-center align-items-center"
    >
      <div
        class="d-flex mr-0 mr-sm-1 mt-1 w-100"
        :class="appleOptions.wrapperCss"
        v-if="appleOptions.enabled"
      >
        <b-button
          variant="outline-dark"
          class="align-items-center btn btn-outline-dark d-flex p-0"
          type="button"
          :class="appleOptions.width"
          :disabled="loading"
          @click="installApp"
        >
          <img :src="appleLogo" class="px-sm-1 px-50" alt="Apple logo" />
          <span
            class="align-items-center align-middle btn btn-block border-left-dark rounded-0 d-flex justify-content-around h-100 w-100 px-sm-1 px-50"
          >
            {{ appleOptions.text }}
          </span>
        </b-button>
      </div>

      <b-button
        class="mt-1 w-100"
        variant="outline-primary"
        type="button"
        :disabled="loading"
        @click="dismissPrompt"
      >
        No, thanks
      </b-button>
    </div>
  </b-toast>
</template>

<script>
import { BButton, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { formToastification } from '@core/mixins/ui/formToastification'
import { handleWebview } from '@core/mixins/ui/handleWebview'
import { mapGetters } from 'vuex'

export default {
  name: 'InstallIOSApp',

  components: {
    BButton,
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  mixins: [formToastification, handleWebview],

  data: () => ({
    shown: false,
    loading: false,
    isAppInstalled: false,

    defaultGoogleOptions: {
      enabled: true,
      text: 'Get it on Google Play',
      variant: 'primary',
      width: 'w-100',
      wrapperCss: 'justify-content-center',
    },

    defaultAppleOptions: {
      enabled: true,
      text: 'Download on the App Store',
      variant: 'primary',
      width: 'w-100',
      wrapperCss: 'justify-content-center',
      url: 'https://apps.apple.com/ro/app/agendum-club/id6444837205',
    },

    googleLogo: require('@/assets/images/icons/google.svg'),
    appleLogo: require('@/assets/images/icons/apple.svg'),

    toastPosition: 'bottom-right',
    logo: require('@/assets/images/logo/logo.svg'),
  }),

  beforeMount() {
    let standalone = window.navigator.standalone,
      userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent)

    if (
      process.env.NODE_ENV === 'production' &&
      ios &&
      !this.isWebview()
    ) {
      this.shown = true
    }
  },

  methods: {
    dismissPrompt() {
      this.shown = false
      this.declineInstalling()
    },

    declineInstalling() {
      this.$cookies.set('agendum_ios_app', {
        install: {
          consent: false,
        },
      })
    },

    acceptInstalling() {
      this.$cookies.set('agendum_ios_app', {
        install: {
          consent: true,
        },
      })
    },

    installApp() {
      this.loading = true
      this.dismissPrompt()
      window.open(this.appleOptions.url, '_blank').focus()
    },

    makeToast() {
      this.$bvToast.show('install-iOS-app-toast')
    },
  },

  computed: {
    ...mapGetters('auth', ['user']),

    userDeclinedInstalling() {
      if (_.isEmpty(this.cookieApp)) {
        return false
      }

      return !this.cookieApp.install.consent
    },

    cookieApp() {
      return this.$cookies.get('agendum_ios_app')
    },

    googleOptions() {
      return {
        ...this.defaultGoogleOptions,
      }
    },
    appleOptions() {
      return {
        ...this.defaultAppleOptions,
      }
    },
  },

  watch: {},
}
</script>

<style scoped></style>
